<template>
  <div>
    <div @click="onClick">
      <Icon name="ellipsis"></Icon>
    </div>
    <ActionSheet v-model="showActions" :actions="actions" :round="false" cancel-text="取消" close-on-click-action
                 @select="onSelect" style="z-index:10000"></ActionSheet>
  </div>
</template>

<script>

  import {Icon, ActionSheet} from "vant"

  export default {
    name: "ProfileEditBtn",
    components: {
      Icon, ActionSheet
    },
    data() {
      return {
        showActions: false,
        actions: [{name: '编辑'}],
      }
    },
    methods: {

      onClick() {
        this.showActions = true
      },
      onSelect(item) {
        this.showActions = false;
        if (item.name === "编辑") {
          this.onToEdit()
        }
      },

      onToEdit() {
        // this.$router.push("")
      }
    }
  }

</script>

<style lang="scss" scoped>

</style>
